// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ToggleButton_checkbox__19qvS","label":"ToggleButton_label__1ky-x","ball":"ToggleButton_ball__jcYCa"};